import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function RevisionSistematica() {
  return <ServiceTemplate serviceName="revicion-sistematica" />;
}
